export default {"src":"/_next/static/media/Arrow-right-white.5b7795f9.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};